import { TFunction } from "i18next";
import { components } from "../types/api";

export const getStatusDisplay = (
  t: TFunction<"translation", undefined>,
  status?: components["schemas"]["CampaignStatus"]
) => {
  const actualStatus = status || "ACTIVE";

  switch (actualStatus) {
    case "ACTIVE":
      return {
        label: t("campaigns.status.active", { defaultValue: "Active" }),
        color: "success" as const,
      };
    case "INACTIVE":
      return {
        label: t("campaigns.status.inactive", { defaultValue: "Inactive" }),
        color: "default" as const,
      };
    case "ENDED":
      return {
        label: t("campaigns.status.ended", { defaultValue: "Ended" }),
        color: "error" as const,
      };
    default:
      return {
        label: actualStatus,
        color: "default" as const,
      };
  }
};
